export default __webpack_public_path__ + "static/media/map.3afb37c2.png";